import { IEntity } from './entity';

export type ILocale = IEntity & {
  id: string;
  title?: string;
  isActive?: boolean;
  isDefault?: boolean;
  isHidden?: boolean;
};
